<div class="tw-py-9 tw-px-6 tw-font-body">
  <h2 class="tw-text-600 tw-font-bold" i18n="@@describeYourConcern">Describe your concern <br/> so the doctor can guide you</h2>
  <p class="tw-text-300 tw-text-gray-500 tw-mt-2 tw-mb-10" i18n="@@doctorWillAnalyseThisAndCallYou">Doctor will analyse this and call you</p>
  <textarea class="tw-w-full tw-h-[17vh] tw-border-2 tw-bg-gray-80 tw-rounded-3 tw-p-2 tw-border-none"
    placeholder="Write here"
    [(ngModel)]="userQuery"
    (ngModelChange)="handleOnChange()"
    i18n-placeholder="@@writeHere">
  </textarea>
  <div class="tw-items-start tw-gap-1.5" [ngClass]="{'tw-flex': invalidUserInputError?.length, 'tw-hidden': !invalidUserInputError?.length}">
    <img src="/assets/images/warn-err.png" class="tw-w-4 tw-mt-0.5" />
    <p class="tw-text-orange-500 tw-text-200 tw-font-normal tw-font">
      {{invalidUserInputError}}
    </p>
  </div>
  <button class="tw-w-full tw-bg-teal-600 tw-text-white tw-rounded-3 tw-py-3 tw-text-center tw-font-bold tw-text-500 tw-mt-8" (click)="onContinue()" i18n="@@continue">Continue</button>
</div>